// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionContent_content__NK2w5","container":"SectionContent_container__jNqQ3","content__container":"SectionContent_content__container__XvPzN"};